import React, { useEffect } from 'react';
import { Grid, Divider, Chip } from '../../../../../../core/components/library';
import { Switch } from 'core/components';
import * as helpers from 'core/helpers';

const Definicion = props => {
    const {
        values,
        editing,
        adding,
        initial,
        handleChange,
        refresh,
        estableceFiltro
    } = props;

    // Definimos a quien afecta
    useEffect(() => {
        if (editing && values.bodega) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'centro', false));
            changes.push(helpers.getValueControl('text', 'etiqueta', false));
            changes.push(helpers.getValueControl('text', 'viticultor', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.bodega)]);

    useEffect(() => {
        if (editing && values.centro) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'bodega', false));
            changes.push(helpers.getValueControl('text', 'etiqueta', false));
            //changes.push(helpers.getValueControl('text', 'viticultor', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.centro)]);

    useEffect(() => {
        if (editing && values.etiqueta) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'bodega', false));
            changes.push(helpers.getValueControl('text', 'centro', false));
            changes.push(helpers.getValueControl('text', 'viticultor', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.etiqueta)]);

    useEffect(() => {
        if (editing && values.viticultor) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'bodega', false));
            //changes.push(helpers.getValueControl('text', 'centro', false));
            changes.push(helpers.getValueControl('text', 'etiqueta', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.viticultor)]);

    // Definimos el comportamiento
    useEffect(() => {
        if (editing && values.alta) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'baja', false));
            changes.push(
                helpers.getValueControl('text', 'modificacion', false)
            );
            changes.push(helpers.getValueControl('text', 'bloqueo', false));
            changes.push(helpers.getValueControl('text', 'produccion', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.alta)]);

    useEffect(() => {
        if (editing && values.baja) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'alta', false));
            changes.push(
                helpers.getValueControl('text', 'modificacion', false)
            );
            changes.push(helpers.getValueControl('text', 'traspaso', false));
            changes.push(helpers.getValueControl('text', 'bloqueo', false));
            changes.push(helpers.getValueControl('text', 'produccion', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.baja)]);

    useEffect(() => {
        if (editing && values.modificacion) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'alta', false));
            changes.push(helpers.getValueControl('text', 'baja', false));
            changes.push(helpers.getValueControl('text', 'traspaso', false));
            changes.push(helpers.getValueControl('text', 'bloqueo', false));
            changes.push(helpers.getValueControl('text', 'produccion', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.modificacion)]);

    useEffect(() => {
        if (editing && values.traspaso) {
            const changes = [];
            //changes.push(helpers.getValueControl('text', 'alta', false));
            changes.push(helpers.getValueControl('text', 'baja', false));
            changes.push(
                helpers.getValueControl('text', 'modificacion', false)
            );
            changes.push(helpers.getValueControl('text', 'bloqueo', false));
            changes.push(helpers.getValueControl('text', 'produccion', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.traspaso)]);

    useEffect(() => {
        if (editing && values.bloqueo) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'alta', false));
            changes.push(helpers.getValueControl('text', 'baja', false));
            changes.push(
                helpers.getValueControl('text', 'modificacion', false)
            );
            changes.push(helpers.getValueControl('text', 'traspaso', false));
            changes.push(helpers.getValueControl('text', 'produccion', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.bloqueo)]);

    useEffect(() => {
        if (editing && values.produccion) {
            const changes = [];
            changes.push(helpers.getValueControl('text', 'alta', false));
            changes.push(helpers.getValueControl('text', 'baja', false));
            changes.push(
                helpers.getValueControl('text', 'modificacion', false)
            );
            changes.push(helpers.getValueControl('text', 'traspaso', false));
            changes.push(helpers.getValueControl('text', 'bloqueo', false));
            handleChange(changes);
        }
    }, [JSON.stringify(values.produccion)]);

    return (
        <Grid container spacing={4}>
            <Grid item xs>
                <Grid container spacing={1} direction={'column'}>
                    <Grid item xs>
                        <Divider style={{ margin: '12px 12px 12px 12px' }}>
                            <Chip size='small' label={'Afecta a'} />
                        </Divider>
                    </Grid>
                    <Grid item xs>
                        <Grid container spacing={1}>
                            <Grid item xs>
                                <Switch
                                    value={values.bodega}
                                    onChange={handleChange}
                                    name='bodega'
                                    label='Bodega'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.centro}
                                    onChange={handleChange}
                                    name='centro'
                                    label='Centro'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.etiqueta}
                                    onChange={handleChange}
                                    name='etiqueta'
                                    label='Etiqueta'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.viticultor}
                                    onChange={handleChange}
                                    name='viticultor'
                                    label='Viticultor'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.parcela}
                                    onChange={handleChange}
                                    name='parcela'
                                    label='Parcela'
                                    editing={editing}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs>
                <Grid container spacing={1} direction={'column'}>
                    <Grid item xs>
                        <Divider style={{ margin: '12px 12px 12px 12px' }}>
                            <Chip size='small' label={'Comportamiento'} />
                        </Divider>
                    </Grid>
                    <Grid item xs>
                        <Grid container spacing={1}>
                            <Grid item xs>
                                <Switch
                                    value={values.alta}
                                    onChange={handleChange}
                                    name='alta'
                                    label='Alta'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.baja}
                                    onChange={handleChange}
                                    name='baja'
                                    label='Baja'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.modificacion}
                                    onChange={handleChange}
                                    name='modificacion'
                                    label='Modificación'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.produccion}
                                    onChange={handleChange}
                                    name='produccion'
                                    label='Produccion'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.bloqueo}
                                    onChange={handleChange}
                                    name='bloqueo'
                                    label='Bloqueo'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.mezcla}
                                    onChange={handleChange}
                                    name='mezcla'
                                    label='Mezcla'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.traspaso}
                                    onChange={handleChange}
                                    name='traspaso'
                                    label='Traspaso'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.venta}
                                    onChange={handleChange}
                                    name='venta'
                                    label='Venta'
                                    editing={editing}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs>
                        <Divider />
                    </Grid>
                    <Grid item xs>
                        <Grid container spacing={1}>
                            <Grid item xs>
                                <Switch
                                    value={values.elaboracion}
                                    onChange={handleChange}
                                    name='elaboracion'
                                    label='Elaboración'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.almacenamiento}
                                    onChange={handleChange}
                                    name='almacenamiento'
                                    label='Almacenamiento'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.crianza}
                                    onChange={handleChange}
                                    name='crianza'
                                    label='Crianza'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.embotellado}
                                    onChange={handleChange}
                                    name='embotellado'
                                    label='Embotellado'
                                    editing={editing}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs>
                <Grid container spacing={1} direction={'column'}>
                    <Grid item xs>
                        <Divider style={{ margin: '12px 12px 12px 12px' }}>
                            <Chip size='small' label={'Requisitos'} />
                        </Divider>
                    </Grid>
                    <Grid item xs>
                        <Grid container spacing={1}>
                            <Grid item xs>
                                <Switch
                                    value={values.acta}
                                    onChange={handleChange}
                                    name='acta'
                                    label='Acta'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.resolucion}
                                    onChange={handleChange}
                                    name='resolucion'
                                    label='Resolución'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.liquidacion}
                                    onChange={handleChange}
                                    name='liquidacion'
                                    label='Liquidación'
                                    editing={editing}
                                />
                            </Grid>
                            <Grid item xs>
                                <Switch
                                    value={values.seguimiento}
                                    onChange={handleChange}
                                    name='seguimiento'
                                    label='Seguimiento'
                                    editing={editing}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Definicion;
